import { render, staticRenderFns } from "./StisticReward.vue?vue&type=template&id=aaa8367e&"
import script from "./StisticReward.vue?vue&type=script&lang=js&"
export * from "./StisticReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports